module.exports = __webpack_public_path__ + "static/media/u2222.50581eff.webp";